import { useState, useEffect, useRef } from 'react';
import { useAtom } from 'jotai';
import { useQuestionToggleAtom } from '../../atoms/chat/useQuestionToggleAtom';
import { useSelectedTabAtom, selectedTabAtom } from '../../atoms/chat/useSelectedTabAtom';
import {useMessageHistoryAtom, messageHistoryAtomSk, messageHistoryAtomEn, messageHistoryAtomCz} from '../../atoms/chat/useMessageHistoryAtom';
import { allowStopAtom } from '../../atoms/chat/useAllowStopAtom';
import { isStoppingAtom } from '../../atoms/chat/useIsStoppingAtom';
import { useFormButtonEnabledAtom } from '../../atoms/chat/useFormButtonEnabledAtom';
import { useFormInputEnabledAtom} from '../../atoms/chat/useFormInputEnabledAtom';
import {selectedQuestionAtom} from "../../atoms/chat/useSelectedQuestionAtom";
import { useChatEnvironmentAtom } from '../../atoms/chat/useChatEnvironmentAtom';
import { appenedChatItem } from '../../services/appendChatItem';
import { sendMessageToBE } from '../../api/questionAPIs';
import { nanoid } from 'nanoid';
import { useTranslation } from 'react-i18next';
import { useTabItemIdAtom } from '../../atoms/chat/useTabItemIdAtom';

import TextArea from './TextArea';
import MessageBubble from '../chat/message/MessageBubble';
import bot from '../../assets/premiumlogo.png';
import avatar from '../../assets/avatar.jpg';



const ChatComponent = () => {
  const [t, i18n] = useTranslation('global');
  const [messageHistory, setMessageHistory] = useMessageHistoryAtom(i18n.language);
  const [isQuestionsVisible, setIsQuestionsVisible] = useQuestionToggleAtom();
  const [selectedTab, setSelectedTab] = useSelectedTabAtom();
  const [formButtonEnabled, setFormButtonEnabled] = useFormButtonEnabledAtom();
  const [formInputEnabled, setFormInputEnabled] = useFormInputEnabledAtom();
  const [chatEnvironmentId, ] = useChatEnvironmentAtom();
  const [, setAllowStop] = useAtom(allowStopAtom);
  const [, setIsStopping] = useAtom(isStoppingAtom);
  const [selectedQuestion, setSelectedQuestion] = useAtom(selectedQuestionAtom);
  const [tabItemId, ] = useTabItemIdAtom();
  const messageListRef = useRef(null);
  const inputRef = useRef(null);
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [allowReset, setAllowReset] = useState(false);
  const [ignoreNext, setIgnoreNext] = useState(false);
  const [allowCancel, setAllowCancel] = useState(false);
  const [result, setResult] = useState({});
  const [formData, setFormData] = useState('');
  const [lastSentMessage, ] = useState([
    {
      intent: 'PromtData',
      message: '',
    },
    {
      intent: 'PromtEmbeddings',
      message: '',
    },
    {
      intent: 'PromptGpt',
      message: '',
    },
  ]);


  useEffect(() => () => {
      var messageHistory;
      if (i18n.language === 'sk') {
        messageHistory = messageHistoryAtomSk.init;
      } else if (i18n.language === 'en') {
        messageHistory = messageHistoryAtomEn.init;
      } else if (i18n.language === 'cz') {
        messageHistory = messageHistoryAtomCz.init;
      }
      setMessageHistory(messageHistory);
      setSelectedTab(selectedTabAtom.init);

  },[]);

  useEffect(() => () => {
      var messageHistory;
      if (i18n.language === 'sk') {
        messageHistory = messageHistoryAtomSk.init;
      } else if (i18n.language === 'en') {
        messageHistory = messageHistoryAtomEn.init;
      } else if (i18n.language === 'cz') {
        messageHistory = messageHistoryAtomCz.init;
      }
      setMessageHistory(messageHistory);
      setSelectedTab(selectedTabAtom.init);

  }, []);

  useEffect(() => {
    if (messageListRef.current) {
      messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
    }

    let currentChat = messageHistory.find(item => item.intent === selectedTab)?.chat;

    if(!currentChat) {
      setAllowReset(false);
    }
    else if (currentChat && currentChat.length > 1) {
      let lastMessage = currentChat[currentChat?.length - 1];
      setAllowReset(true);

      if (lastMessage && lastMessage.Type === 'loading') {
        setAllowReset(false);
        setAllowStop(true);
      } else {
        setAllowStop(false);
      }
    } 

    inputRef.current.focus();

  }, [messageHistory, selectedTab]);

  // new 
  // useEffect(() => {
  //   if (messageListRef.current) {
  //     messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
  //   }

  //   let currentChat = messageHistory.find(item => item.intent === selectedTab)?.chat;
  //   let lastMessage = currentChat[currentChat.length - 1];
  //   if (currentChat.length > 1) {
  //     setAllowReset(true);
  //   } else {
  //     setAllowReset(false);
  //   }

  //   if (lastMessage && lastMessage.Type === 'loading') {
  //     setAllowReset(false);
  //     setAllowStop(true);
  //   } else {
  //     setAllowStop(false);
  //   }

  //   inputRef.current.focus();

  // }, [messageHistory, selectedTab]);

  useEffect(() => {
    handleResponse(result, ignoreNext);

    const timer = setTimeout(() => {
      if (messageListRef.current) {
        messageListRef.current.scrollTop = messageListRef.current.scrollHeight;
      }
    }, 500); 
  
    return () => clearTimeout(timer); 

  }, [result]);


    useEffect(() => {
      if (!!selectedQuestion) {
        setFormData(selectedQuestion);
        setTimeout(() => {
          handleSubmit(undefined, selectedQuestion);
          setSelectedQuestion('');
        }, 100);
      }
    }, [selectedQuestion]);

  const handleChange = (e) => {
    setFormData(e.target.value);
    setIsInputEmpty(e.target.value.trim() === '');
  };

  const toggleQuestions = () => {
    setIsQuestionsVisible((prevState) => !prevState);
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'ArrowUp') {
      var data = lastSentMessage.find((item) => item.intent === selectedTab);
      setFormData(data.message);

      setTimeout(() => {
        const inputField = document.querySelector('.msger-input');
        if (inputField) {
          inputField.setSelectionRange(data.message.length, data.message.length);
        }
      }, 0);
    }

    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault(); // Prevent new line
      handleSubmit(e);
    }
  };

  function formatDate(date) {
    const h = '0' + date.getHours();
    const m = '0' + date.getMinutes();

    return `${h.slice(-2)}:${m.slice(-2)}`;
  }

  const handleStop = (e) => {
    e.preventDefault();
    setIsStopping(true);

    messageHistory.find(item => item.intent === selectedTab)?.chat.pop(-2);

    messageHistory.find(item => item.intent === selectedTab)?.chat.push({
      Message: t('responseStopped'),
      sent: formatDate(new Date()),
      Role: 'user',
      Type: 4,
      id: nanoid()
    });
  }

  const handleReset = (e) => {
      e.preventDefault();
      setIsInputEmpty(true);
      messageHistory.find(item => item.intent === selectedTab)?.chat.push({
          Message: t('resetContextSeparator'),
          sent: formatDate(new Date()),
          Role: "user",
          Type: 5,
          id: nanoid(),
      });

      setAllowReset(false);
      setIsStopping(false);
      setIsInputEmpty(false);
  }

  const handleCancel = (e) => {
      e.preventDefault();

      setIgnoreNext(true);
      handleStop(e);
  }

  const handleSubmit = (e, question) => {
    e?.preventDefault();
    const data = !!question ? question : formData;
    if (!data.length > 0) {
      return;
    }

    setIsInputEmpty(true);
    setFormInputEnabled(false);
    setFormButtonEnabled(false);
    setAllowCancel(true);

    var selectedObject = lastSentMessage.find((item) => item.intent === selectedTab);
    selectedObject.message = data;

    if (data) {
      const newId = nanoid();
      setMessageHistory(
        appenedChatItem(
          selectedTab, {
            Message: data,
            sent: formatDate(new Date()),
            Role: 'assistant',
            Type: 'loading',
            id: nanoid(),
          },
          appenedChatItem(
            selectedTab, {
              Message: data,
              sent: formatDate(new Date()),
              Role: 'user',
              Type : 0,
              id: newId
            },
            messageHistory
          )
        )
      );

      const env = selectedTab === 'PromtData' ? null : chatEnvironmentId;
      /* NEW
            const getMessageParams = (selectedTab, defaultEnv = null, defaultTab = null) => {
        if (selectedTab === 'PromtData' || selectedTab === 'PromptGpt') {
          return { env: defaultEnv, tab: tabItemId };
        }
        if (selectedTab === 'PromtEmbeddings') {
          return { env: chatEnvironmentId, tab: defaultTab };
        }
        return { env: defaultEnv, tab: defaultTab };
      };
      
      const { env, tab } = getMessageParams(selectedTab);
      .....
       sendMessageToBE(selectedTab, messageHistory, data, newId, env, tab)
      */
      sendMessageToBE(selectedTab, messageHistory, data, newId, env)
      .then((message) => {
        setResult(message);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setFormInputEnabled(true);
        setFormButtonEnabled(true);
        setAllowCancel(false);
      });
    }

    setAllowStop(false);
    setIsStopping(false);

    setIsInputEmpty(true);
    setFormData('');
  };

  const removeLoading = (messageHistory, selectedTab) => {
    const chat = messageHistory.find(item => item.intent === selectedTab)?.chat;
    const lastMessage = chat[chat.length - 1];
    if (lastMessage && lastMessage.Type === 'loading') {
      chat.pop();
    }
  }

  const handleResponse = (message, ignoreNext = false) => {
    if (ignoreNext) {
      setIgnoreNext(false);
      return;
    }

    removeLoading(messageHistory, selectedTab, message.newId);

    if(message.Type === 0 && message.Status === 'ERROR' && message.Message != undefined){
      message.Message = t(message.Message);
    }

    if (message.Type === 0) {
      console.log('type text');
      setMessageHistory(
        appenedChatItem(
          selectedTab,
          {
            Message: message.Message,
            sent: formatDate(new Date()),
            Role: message.Role,
            Type: message.Type,
            //GeneratedSQL: message.GeneratedSQL,
            id: nanoid(),
          },
          messageHistory
        )
      );
    }
    else if (message.Type === 1) {
      setMessageHistory(
        appenedChatItem(
          selectedTab,
          {
            Table: { Rows: message.Message.Rows, Columns: message.Message.Columns },
            SystemMessage: message.SystemMessage,
            //GeneratedSQL: message.GeneratedSQL,
            sent: formatDate(new Date()),
            Role: message.Role,
            Type: message.Type,
            id: nanoid(),
          },
          messageHistory

        )
      );
    }
    else if (message.Type === 2) {
      console.log(message);
      setMessageHistory(
        appenedChatItem(
          selectedTab,
          {
            Message: message.Message,
            sent: formatDate(new Date()),
            Role: message.Role,
            Type: message.Type,
            id: nanoid(),
          },
          messageHistory
        )
      );
    }
    else if (message.Type === 3) {
      setMessageHistory(
        appenedChatItem(
          selectedTab,
          {
            Message: message.Message,
            MessageID : message.MessageID,
            sent: formatDate(new Date()),
            Role: message.Role,
            Type: message.Type,
            EnvironmentType: message.EnvironmentType,
            id: nanoid(),
            Metadata: message.Metadata
          },
          messageHistory
        )
      );
    }
  }

  return (
    <div ref={messageListRef} className={`context-wrap focus`}>
      <main className="msger-chat">
        {messageHistory
          .filter((item) => item.intent === selectedTab)
          .map((item) =>
            item.chat.map((item) => (
              item.Type === 5 ? (
                <div className="reset-separator" key={item.id}>
                  <span className='reset-text'>{item.Message}</span>
                </div>
              ) : (
              <MessageBubble
                key = {item.id}
                id = {item.id}
                type = {item.Type}
                envType = {item.EnvironmentType}
                message = {item.Message ? item.Message : item.Table}
                messageId = {item.MessageID}
                meta = {item.Metadata}
                sent = {item.sent}
                role = {item.Role}
                //generatedSQL = {item.GeneratedSQL}
                bot = {bot}
                avatar = {avatar}
              />
              )
            ))
          )}

          {allowReset ?
              <div className='reset-area'>
                <div onClick={handleReset}>
                  <span className='reset-icon material-symbols-outlined'>replay</span>
                  <label className='reset-text'>{t('resetContext')}</label>
                </div>
              </div> : null }

          {allowCancel ?
              <div className='cancel-area' onClick={handleCancel}>
                <span className='cancel-icon material-symbols-outlined'>stop</span>
                <label className='cancel-text'>{t('cancel')}</label>
              </div> : null }
      </main>


      <form className="chat-form" onSubmit={handleSubmit}>
        <div
          id="questionButton"
          className={`question-list-button ${isQuestionsVisible ? 'clicked' : ''}`}
          onClick={toggleQuestions}
        >
          <span className="material-symbols-outlined">list</span>
        </div>
          <TextArea
            value={formData}
            disabled={!formInputEnabled}
            autoComplete="off"
            onChange={handleChange}
            onKeyDown={handleInputKeyDown}
            onEnterPress={handleSubmit}
            ref={inputRef}
          />
          <button 
            type="submit" 
            className={`msger-send-btn ${isInputEmpty ? 'hidden' : ''}`}  
            disabled={!formButtonEnabled}
          >
            {formInputEnabled ? (
              <>
              <span className="material-symbols-outlined">arrow_upward_alt</span>
              <span className="send-text">{t('send')}</span>
              </>
            ) : (
              <>
              <span className="material-symbols-outlined">hourglass_empty</span>
              <span className="send-text">{t('working')}</span>
              </>
            )}
        </button>
      </form>
    </div>
  );
};

export default ChatComponent;
